import { request } from "../../httpClient";

export const getUserListRequest = async () => {
  const res = await request({
    path: "user/protected/user-list",
  });
  return res;
};
